import { render, staticRenderFns } from "./SettingsMedRecord.vue?vue&type=template&id=ef4902c6"
import script from "./SettingsMedRecord.vue?vue&type=script&lang=js"
export * from "./SettingsMedRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports